export const INITIAL_ACTIVITY_FORM = {
  id: "new",
  name: "",
  description: "",
  color: "#3c5068",
  status: "ativo",
  active: true,
  objectives: [],
}

